module.exports = __webpack_public_path__ + "static/media/Time-Released-23-main_header.638a182c.gif";